if (!customElements.get('dmg-product-links')) {
  customElements.define('dmg-product-links', class extends HTMLElement {
    connectedCallback() {
      this.source = this.closest('product-info');
      this.blockPending = event => {
        if (this.getAttribute('aria-busy') === 'true' && event.target.closest('a')) event.preventDefault();
      };
      this.addEventListener('click', this.blockPending);
      if (this.dataset.role === 'seal') return;
      this.onSelection = ({data}) => {
        if (this.source?.contains(data.event.target)) {
          this.setAttribute('aria-busy', 'true');
          this.querySelectorAll('a').forEach(a => a.setAttribute('aria-disabled', 'true'));
        }
      };
      this.onVariant = ({data}) => {
        if (data.sectionId !== this.dataset.sectionId) return;
        const id = String(data.variant?.id || '');
        this.querySelectorAll('[data-source-variant]').forEach(row => { row.hidden = row.dataset.sourceVariant !== id; });
        this.removeAttribute('aria-busy');
        this.querySelectorAll('a').forEach(a => a.removeAttribute('aria-disabled'));
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeSelection = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.onSelection);
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant);
      }
    }
    disconnectedCallback() {
      this.unsubscribeSelection?.();
      this.unsubscribeVariant?.();
      this.removeEventListener('click', this.blockPending);
    }
  });
}
